import { placeTitleForExport, type PlaceTitleSettings } from './place-title-settings';

export function PlaceTitleControls({ value, onChange, onReplay, onLookup, replaying = false }: {
  replaying?: boolean;
  value: PlaceTitleSettings; onChange: (value: PlaceTitleSettings) => void; onReplay: () => void;
  onLookup: () => void;
}) {
  const pending = value.lookup === 'pending';
  const invalid = value.enabled && !pending && !placeTitleForExport(value);
  return <fieldset className="studio-control-group studio-place-title"><legend>Place title</legend>
    <label className="studio-check"><input type="checkbox" checked={value.enabled}
      onChange={event => onChange({ ...value, enabled: event.target.checked })} />Show place title in opening</label>
    <label>Place name<input type="text" value={value.name} maxLength={120} disabled={!value.enabled}
      aria-invalid={invalid} onChange={event => onChange({ ...value, name: event.target.value })} /></label>
    <label>Region / state (optional)<input type="text" value={value.region} maxLength={120} disabled={!value.enabled}
      onChange={event => onChange({ ...value, region: event.target.value })} /></label>
    {pending && <p role="status">Finding place name from the trace’s start…</p>}
    {value.lookup === 'resolved' && <p>Suggested from the trace’s starting location. You can edit both lines.</p>}
    {value.lookup === 'unavailable' && <p role="status">Couldn’t find the starting place. Try again, or enable the title and enter a place name.</p>}
    {invalid && <p role="status">Enter a place name.</p>}
    <div className="studio-inline"><button type="button" disabled={pending} onClick={onLookup}>Use starting location</button>
      <button type="button" aria-pressed={replaying} disabled={!value.enabled || !placeTitleForExport(value)} onClick={onReplay}>Replay opening</button></div>
  </fieldset>;
}
